import React, { Component } from 'react'
import ActionHeader from './ActionHeader.js'
import StatusButtons from '.././components/buttons/statusButtons.js'
import config from '../resource/appConfig.js'
import FulfilledSummary from '../components/panels/requestSummary/FulfilledRequestSummary.js'
import RequestSummary from '../components/panels/requestSummary/RequestSummary.js'

const U = config.reqStatuses.uploaded,
    S = config.reqStatuses.submit,
    VIP = config.reqStatuses.validationInProgress,
    VF = config.reqStatuses.validationFailed,
    VSW = config.reqStatuses.validationSuccesswithErrors,
    VS = config.reqStatuses.validationSuccessful,
    FF = config.reqStatuses.fulfilled,
    FWF = config.reqStatuses.fulfilledWithFailures

class StatusActions extends Component {
    render() {
        const dataItems = this.props.request
        const reqstatus = dataItems.REQ_STATUS
        return (
            <div className="panel panel-status">
                <ActionHeader request={this.props.request} apiAuthHeaders={this.props.apiAuthHeaders}
                              index={this.props.index} />
                <div className="col-xs-9" aria-live="polite">
                    <div className="cb-stepper" data-cb-rstatus="finish" data-cb-stepper-total="5" aria-label=""
                         role="region">
                        <ol>
                            <li data-cb-stepper-step="1"
                                className={(reqstatus === U || reqstatus === VIP || reqstatus === VF || reqstatus === VSW || reqstatus === VS || reqstatus === S || reqstatus === FF || reqstatus === FWF) ? 'cb-stepper-complete' : ''}>
                                <span aria-hidden="true" className="cb-glyph cb-glyph-circular cb-check"
                                      data-cb-stepper-glyph="cb-upload">
                                </span><p>Upload</p><span
                                className="sr-only cb-stepper-step">step 1 of 5 completed</span>
                            </li>
                            <li data-cb-stepper-step="2"
                                className={(reqstatus === U || reqstatus === VIP || reqstatus === VF || reqstatus === VSW || reqstatus === VS || reqstatus === S || reqstatus === FF || reqstatus === FWF) ?
                                    ((reqstatus === U || reqstatus === VIP) ? 'cb-stepper-active' : 'cb-stepper-complete') : ''}><span
                                aria-hidden="true"
                                className={(reqstatus === VS || reqstatus === VF || reqstatus === VSW || reqstatus === S) ? 'cb-glyph cb-glyph-circular cb-check' : 'cb-glyph cb-glyph-circular cb-pending'}
                                data-cb-stepper-glyph="cb-pending">
                                </span><p>Validation In Progress</p><p></p><span
                                className="sr-only cb-stepper-step">{(reqstatus === U || reqstatus === VIP ? 'step 2 of 5 in progress' : 'step 2 of 5 completed')}</span>
                            </li>
                            <li data-cb-stepper-step="3"
                                className={(reqstatus === VF || reqstatus === VSW || reqstatus === VS || reqstatus === S || reqstatus === FF || reqstatus === FWF) ?
                                    ((reqstatus === VF || reqstatus === VSW) ? 'cb-stepper-active' : 'cb-stepper-complete')
                                    : ''}><span aria-hidden="true"
                                                className={(reqstatus === VS || reqstatus === S ? 'cb-glyph cb-glyph-circular cb-check' : 'cb-glyph cb-glyph-circular cb-resources')}
                                                data-cb-stepper-glyph="cb-resources">
                                </span><p>Fix Errors / Warnings</p><p></p><span
                                className="sr-only cb-stepper-step">{(reqstatus === U || reqstatus === VIP) ? 'step 3 of 5 pending' : (reqstatus === VF || reqstatus === VSW) ? 'step 3 of 5 in progress' : 'step 3 of 5 completed'}</span>
                            </li>
                            <li data-cb-stepper-step="4"
                                className={(reqstatus === VS || reqstatus === S || reqstatus === FF || reqstatus === FWF) ?
                                    ((reqstatus === VS || reqstatus === S) ? 'cb-stepper-complete' : 'cb-stepper-complete')
                                    : ''}><span aria-hidden="true"
                                                className={(reqstatus === VS || reqstatus === S ? 'cb-glyph cb-glyph-circular cb-check' : 'cb-glyph cb-glyph-circular cb-icon-icn_settings')}
                                                data-cb-stepper-glyph="cb--icon-icn_settings"></span><p>Validate
                                Changes </p><p></p>
                                <span
                                    className="sr-only cb-stepper-step">{(reqstatus === VS || reqstatus === S || reqstatus === FF || reqstatus === FWF) ? 'step 4 of 5 completed' : 'step 4 of 5 pending'}</span>
                            </li>
                            <li data-cb-stepper-step="5"
                                className={(reqstatus === VS || reqstatus === S || reqstatus === FF || reqstatus === FWF) ?
                                    ((reqstatus === VS || reqstatus === S || reqstatus === FF || reqstatus === FWF) ? 'cb-stepper-active' : 'cb-stepper-complete') : ''}><span
                                aria-hidden="true"
                                className={(reqstatus === S ? 'cb-glyph cb-glyph-circular cb-check' : 'cb-glyph cb-glyph-circular cb-east')}>
                                </span><p>Submit</p><p></p><span
                                className="sr-only cb-stepper-step">{(reqstatus === VS) ? 'step 5 of 5 in progress' : (reqstatus === S || reqstatus === FF || reqstatus === FWF) ? 'step 5 of 5 completed' : 'step 5 of 5 pending'}</span>
                            </li>
                        </ol>
                    </div>
                    {dataItems.UPLOAD_TYPE !== "4" && reqstatus !== VIP ?
                        (reqstatus === FF || reqstatus === FWF ? <FulfilledSummary dataItems={dataItems} /> :
                            <RequestSummary dataItems={dataItems} />) : null}
                </div>
                <StatusButtons apiAuthHeaders={this.props.apiAuthHeaders} PassDataItems={this.props.request}
                               index={this.props.index} />
            </div>
        )
    }
}

export default StatusActions
